module.exports = __webpack_public_path__ + "static/media/gc-failed.1436d49a.svg";